export default __webpack_public_path__ + "static/img-3-57a67669f927a16885d6cf26e1f7cd3c.png";